import { prefixerI } from '.'

export const ROUTE_COSTO_KARDEX = prefixerI('costo-kardex')
export const ROUTE_ESTADO_INVENTARIO = prefixerI('estado-inventario')
export const ROUTE_ESTADO_INVENTARIO_ROTACION = prefixerI('estado-inventario-rotacion')
export const ROUTE_INFORME_REPOSICION = prefixerI('informe-reposicion')
export const ROUTE_KARDEX = prefixerI('kardex')
export const ROUTE_MOVIMIENTO_INVENTARIO = prefixerI('movimiento-inventario')
export const ROUTE_MOVIMIENTO_INVENTARIO_GENERAL = prefixerI('movimiento-inventario-general')
export const ROUTE_MOVIMIENTO_TRANSFERENCIAS_AUTOMATICAS = prefixerI('movimiento-transferencias-automaticas')
export const ROUTE_ROTACION_ANTIGUEDAD_INVENTARIO = prefixerI('rotacion-antiguedad-inventario')
export const ROUTE_NOTA_INGRESO_EGRESO = prefixerI('nota-ingreso-egreso')
export const ROUTE_RESUMEN_INVENTARIO = prefixerI('resumen-inventario')
export const ROUTE_ROTACION_INVENTARIO = prefixerI('rotacion-inventario')
export const ROUTE_STOCK_MINIMO = prefixerI('stock-minimo')
export const ROUTE_TOMA_INVENTARIO = prefixerI('toma-inventario')
export const ROUTE_POLITICAS_ITEM = prefixerI('politicas-item')
